const getUniqueID = () => {
	const gen = () => {
		return Math.floor((1 + Math.random()) * 0x1100).toString(16).substring(1)
	}
	return gen() + gen() + '-' + gen()
}

export default getUniqueID
